export interface FAQItem {
  question: string;
  answer: string;
  category?: string;
}

export const generalFAQs: FAQItem[] = [
  {
    question: "What is Quixocial?",
    answer: "Quixocial is an AI-powered social media management platform that helps businesses, agencies, and creators generate, schedule, and analyze social media content across multiple platforms from a single dashboard.",
    category: "general"
  },
  {
    question: "How does Quixocial's AI content generation work?",
    answer: "Quixocial uses the latest and greatest AI models to generate professional content that understands your brand guidelines and generation options. You can keep it simple by chosing the generation options that best fit your use case, or dive deeper into our advanced options to get the most out of Quixocial's capabilities.",
    category: "features"
  },
  {
    question: "Which social media platforms does Quixocial support?",
    answer: "Quixocial currently supports Instagram and Facebook. We are constantly adding new platform integrations based on user demand. We currently have Twitter/X, LinkedIn, TikTok, YouTube, and Pinterest on our near future roadmap.",
    category: "features"
  },
  {
    question: "Can I try Quixocial for free?",
    answer: "Yes! We offer a Free plan that comes with monthly renewable credits. No credit card required to get started.",
    category: "pricing"
  },
  {
    question: "What are credits and how do they work?",
    answer: "Credits are used for AI-powered features like content generation, image enhancement, 3D model creation, and Image analysis. Each AI task consumes a certain amount of credits based on complexity. Credits reset monthly with your subscription.",
    category: "pricing"
  },
  {
    question: "Can I change my plan later?",
    answer: "Absolutely! You can upgrade or downgrade your plan at any time from your account settings. Changes are prorated, and you'll only pay the difference. There are no long-term contracts or cancellation fees.",
    category: "pricing"
  },
  {
    question: "Do you offer team collaboration features?",
    answer: "Yes, our paid plans include comprehensive team collaboration features with role-based permissions, shared workspaces, client management tools, and approval workflows.",
    category: "features"
  },
  {
    question: "Is my data secure with Quixocial?",
    answer: "Security is our top priority. We use enterprise-grade encryption, secure cloud storage, and comply with GDPR and other privacy regulations. Your content and data are always protected and never shared with third parties.",
    category: "security"
  },
  {
    question: "How does Quixocial maintain brand consistency?",
    answer: "Quixocial includes a comprehensive brand kit management system that stores your brand colors, logo, and voice. You can chose to integrate that into your generations as you see fit, ensuring consistent branding across all content and platforms.",
    category: "features"
  },
  {
    question: "Can I schedule content in advance?",
    answer: "Yes! For paid plans, Quixocial includes a powerful scheduling system that allows you to plan and schedule content weeks or months in advance across all your connected social media platforms.",
    category: "features"
  }
];

export const pricingFAQs: FAQItem[] = [
  {
    question: "What if I need more credits than my plan includes?",
    answer: "We offer credit packs that you can purchase at any time from your Billing dashboard.",
    category: "pricing"
  },
  {
    question: "Do you offer annual discounts?",
    answer: "Yes! Annual plans come with significant savings - up to 17% off compared to monthly billing. You'll also get priority support and additional bonus features with annual subscriptions.",
    category: "pricing"
  },
  {
    question: "Is there a free trial for paid plans?",
    answer: "No, we offer a better option; a Free plan with monthly renewable credits.",
    category: "pricing"
  },
  {
    question: "What happens if I cancel my subscription?",
    answer: "You can cancel your subscription at any time. Your account will remain active until the end of your current billing period, and you'll retain access to all your content. After cancellation, you'll automatically move to the free plan.",
    category: "pricing"
  },
  {
    question: "Do you offer custom enterprise pricing?",
    answer: "Yes, we offer custom enterprise solutions with dedicated support, custom integrations, advanced analytics, tailored credit packages, and volume discounts. Contact our sales team for a personalized quote.",
    category: "pricing"
  },
  {
    question: "How does billing work?",
    answer: "We bill monthly or annually based on your chosen plan. All payments are processed securely through Stripe. You'll receive an invoice via email, and you can manage your billing from your account dashboard.",
    category: "pricing"
  }
];

export const featureFAQs: FAQItem[] = [
  {
    question: "How accurate is Quixocial's AI content generation?",
    answer: "Our AI content generation is highly accurate and continuously improving. It learns from your brand's voice, colors, and guidelines and feeds back to create increasingly relevant content.",
    category: "features"
  },
  {
    question: "Does Quixocial provide analytics and reporting?",
    answer: "Yes, our paid plans include comprehensive analytics and reporting. Track engagement, reach, follower growth, and ROI across all platforms. Export reports for clients or stakeholders with white-label options available.",
    category: "features"
  },
  {
    question: "Can I manage multiple client accounts?",
    answer: "Yes! Quixocial is designed for agencies and freelancers managing multiple clients. Each client gets their own workspace with separate brand kits, content libraries, and team access. Perfect for scaling your agency operations.",
    category: "features"
  },
  // {
  //   question: "What types of content can Quixocial create?",
  //   answer: "Quixocial can create images, videos, carousel posts, stories, reels, AR advertisements, blog post graphics, infographics, and more. Our AI adapts content format and dimensions automatically for each social platform.",
  //   category: "features"
  // }
];

export const allFAQs = [...generalFAQs, ...pricingFAQs, ...featureFAQs];